const state = {
  isUserSellerScoreLoaded: false,
  userSellerScore: null,
  isGroupSellerScoreLoaded: false,
  groupSellerScore: null
}

export default state
